module.exports = __webpack_public_path__ + "static/media/10.286520fd.png";